import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "src/config/apiBase";
import { toast } from "react-toastify";

const CrmPartnerSubmitPage = () => {
  const [params] = useSearchParams();
  const defaultKey = params.get("key") || "";
  const [partnerKey, setPartnerKey] = useState(defaultKey);
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    city: "",
    pincode: "",
    business_name: "",
    description: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const url = API_BASE_URL;

  const canSubmit = useMemo(
    () => partnerKey.trim() && form.mobile.trim() && !submitting,
    [partnerKey, form.mobile, submitting]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${url}/leads/partner-submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Partner-Key": partnerKey.trim(),
        },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        toast.error(data.message || "Submit failed");
        return;
      }
      setDone(true);
      toast.success("Lead submitted successfully");
      setForm({
        name: "",
        mobile: "",
        email: "",
        city: "",
        pincode: "",
        business_name: "",
        description: "",
      });
    } catch {
      toast.error("Network error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="crm-partner-submit-page">
      <div className="crm-partner-submit-page__card">
        <h1>Partner lead submission</h1>
        <p className="crm-insights__muted">Submit enquiries on behalf of your agency. Requires a valid partner API key.</p>

        {done && (
          <p className="crm-partner-submit-page__success">Thank you — your lead was received.</p>
        )}

        <form onSubmit={handleSubmit}>
          <label>
            Partner API key
            <input
              type="password"
              value={partnerKey}
              onChange={(e) => setPartnerKey(e.target.value)}
              placeholder="Paste your partner key"
              required
            />
          </label>
          <label>
            Contact name
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </label>
          <label>
            Mobile *
            <input
              value={form.mobile}
              onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              required
            />
          </label>
          <label>
            Email
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </label>
          <label>
            Business name
            <input
              value={form.business_name}
              onChange={(e) => setForm({ ...form, business_name: e.target.value })}
            />
          </label>
          <label>
            City
            <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
          </label>
          <label>
            Pincode
            <input value={form.pincode} onChange={(e) => setForm({ ...form, pincode: e.target.value })} />
          </label>
          <label>
            Notes
            <textarea
              rows={3}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
          </label>
          <button type="submit" disabled={!canSubmit}>
            {submitting ? "Submitting…" : "Submit lead"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CrmPartnerSubmitPage;
